var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background-color":"#e8e8e8"}},[(_vm.isClientSet)?_c('div',[_c('router-view')],1):_c('div',[_c('fail')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }